import React from 'react';

import CustomerForm from '../../page_components/CustomerForm';

function Customer() {
  return (
    <div className="px-48">
      <CustomerForm />
    </div>
  );
}

export default Customer;
